export const getItemFromLocalStorage = (key: string) => {
  let data;
  if (localStorage.getItem(key)) {
    data = JSON.parse(localStorage.getItem(key) || "{}");
  }
  return data !== undefined && data !== null && data !== "undefined"
    ? data
    : undefined;
};

export const setItemToLocalStorage = (key: string, data: any) => {
  localStorage.setItem(key, JSON.stringify(data));
};

export const removeItemFromLocalStorage = (key: string) => {
  localStorage.removeItem(key);
};
export const setItemToSessionStorage = (key: string, data: any) => {
  sessionStorage.setItem(key, JSON.stringify(data));
};
export const getItemFromSessionStorage = (key: string) => {
  let data;
  if (sessionStorage.getItem(key)) {
    data = JSON.parse(sessionStorage.getItem(key) || "{}");
  }
  return data !== undefined && data !== null && data !== "undefined"
    ? data
    : undefined;
};
export const removeItemFromSessionStorage = (key: string) => {
  sessionStorage.removeItem(key);
};
